<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template v-slot:department>
        <el-select multiple v-model="filters.department" placeholder="请选择">
          <el-option
            v-for="item in departmentList"
            :label="item.departmentName"
            :value="item.orgDepartmentID"
            :key="item.orgDepartmentID"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:operationType>
        <el-select multiple v-model="filters.operationType" placeholder="请选择">
          <el-option
            v-for="item in OperationTypeList"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="ImageDiag">
        <el-link
          :underline="false"
          type="primary"
          v-if="scope.row.imageID > 0"
          @click.native="getImage(scope.row.imageID)"
          >查看
        </el-link>
      </template>

        <template slot-scope="scope" slot="file">
        <div v-if="scope.row.stockingTaskID>0">
         
          <span v-if="scope.row.operationType == 100">
            <el-link  v-if="scope.row.isUploadPackPic == true"
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.stockingTaskID, 1)"
            >
              查看
            </el-link>
            
          </span>
           <span v-if="scope.row.operationType == 110">
            <el-link  v-if="scope.row.isUploadBoxMarkPic == true"
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.stockingTaskID, 2)"
            >
              查看
            </el-link>
            
          </span>
           <span v-if="scope.row.operationType == 120">
            <el-link v-if="scope.row.isLoading > 0"
              :underline="false"
              type="primary"
              @click.native="getLoadCarInfoImages(scope.row.stockingTaskID)"
            >
              查看
            </el-link>
            
          </span>
          <br />
         
        </div>
      </template>
    </TwTable>

    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 32, businessCode: currentRow.ioDataNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
  </div>
</template>
<style>
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>
<script>
import { getSignForImage } from "@/api/mobile/signIn_api";
import {
  getDepartmentList,
  GetDeliverGoodProductionTypeList,
  GetDeliverGoodProductionReport,
  ExportDeliverGoodProductionReport,
} from "@/api/report/deliverGoodProductionReport.js";

import {
  getReadyforTaskReviewImages,
} from "@/api/outbound/readyforTask.js";

import {
  getLoadCarInfoReviewImages,
  
} from "@/api/outbound/loadingOrder.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "120",
          options: [
            {
              prop: "resynchronize",
              name: "重新同步",
              size: "small",
              type: "text",
              slot: true,
            },
            // {
            //   name: "日志",
            //   size: "small",
            //   type: "text",
            //   event: "getbusinessLoglist", // 操作的事件名
            // },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: false,
            minWidth: "80",
          },
          {
            prop: "operationTypeDesc",
            label: "操作类型",
            align: "left",
            sortable: false,
            minWidth: "100",
             formatter: function (val, row) {
              return (
                "<span>类型:" +
                (row.operationTypeDesc || "") +
                "</span><br /><span>方式:" +
                (row.packagingTypeName || "") +
                "</span><br />"
               
              );
            },
          },
          {
            prop: "externalNo",
            label: "参考信息",
            align: "left",
            sortable: false,
            minWidth: "150",
            formatter: function (val, row) {
              return (
                "<span>运输方式:" +
                (row.transportType || "") +
                "</span><br /><span>计划编码:" +
                (row.sourceNo || "") +
                "</span><br /> <span>货柜号:" +
                (row.containerNo || "") +
                "</span><br /><span>部门:" +
                (row.departmentName || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "productoInfo",
            label: "产品信息",
            align: "left",
            sortable: false,
            minWidth: "180",
            formatter: function (val, row) {
              return (
                "<span>编码:" +
                (row.sku || "") +
                "</span><br /><span>名称:" +
                (row.productNameCN || "") +
                "</span><br /> "
              );
            },
          },
          {
            prop: "zong",
            label: "总量信息",
            align: "left",
            sortable: false,
            minWidth: "100",
            formatter: function (val, row) {
              return (
                "<span>数量(pcs):" +
                (row.pcs || "") +
                "</span><br /><span>体积(cbm):" +
                (row.totalVolume || "") +
                "</span><br/> "
              );
            },
          },

          
          {
            prop: "box",
            label: "装箱信息",
            align: "left",
            sortable: false,
            minWidth: "140",
            formatter: function (val, row) {
              return (
                "<span>箱规(cm):" +
                row.boxLength  +
                "*" +
                row.boxWidth +
                "*" +
                row.boxHeight +
                "</span><br />" +
                "<span>单箱数量:" +
                row.singleBoxQty+
                "</span><br /> " +
                "<span>单箱重量:" +
                row.boxWeight  +
                "</span><br /> " +
                "<span>总箱数：" +
                row.boxCount +
                "</span><br/> "
              );
            },
          },

          
           {
            prop: "boxTypeName",
            label: "箱子类型",
            align: "center",
            sortable: false,
            minWidth: "80",
          },
          {
            prop: "weixiang",
            label: "FBA信息",
            slot: false,
            minWidth: "140",
            align: "left",
            formatter: function (val, row) {
              return (
                "<span>FNSKU:" +
                (row.fnsku||"") +
                "</span><br />" +
                "<span>SHIPMENTID:" +
                (row.shipmentID||"") +
                "</span><br /> "+
                 "<span>箱唛条码:" +
                (row.boxMark||"") +
                "</span><br /> "
              );
            },
          },

          {
            prop: "optopn",
            label: "操作信息",
            align: "left",
            sortable: false,
            minWidth: "180",
            formatter: function (val, row) {
              return (
                "<span>操作人员:" +
                (row.operator || "") +
                "</span><br />" +
                "<span>操作时间:" +
                (row.operationDateDesc || "") +
                "</span><br /> "
              );
            },
          },
          {
            prop: "file",
            label: "图片",
            align: "center",
            sortable: false,
            slot: true,
            minWidth: "110",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "Operator",
            label: "操作员",
            placeholder: "请输入操作员",
            clearable: true,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "操作日期",
          },
          {
            type: "select",
            key: "department",
            prop: "department",
            label: "部门",
            multiple: true,
            slot: true,
            placeholder: "请选择部门",
            option: this.departmentList,
          },
          {
            type: "select",
            key: "operationType",
            prop: "operationType",
            label: "操作类型",
            multiple: true,
            slot: true,
            placeholder: "操作类型",
            option: this.OperationTypeList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "input",
            key: "SourceNo",
            prop: "SourceNo",
            label: "计划编码",
            multiple: true,
            placeholder: "请输入计划编码",
          },
          {
            type: "input",
            key: "ContainerNo",
            prop: "ContainerNo",
            label: "货柜号",
            multiple: true,
            placeholder: "请输入货柜号",
          },

          {
            type: "input",
            key: "SKU",
            prop: "SKU",
            label: "SKU",
            multiple: true,
            placeholder: "请输入SKU编码",
          },
        ],
      },
      buttonList: [],

      //-------------
      ioTypeIDList: [], //出入库类型
      warehouses: [],
      ioStatusList: [], //状态
      synchStatusList: [], //同步状态
      srcList: [], //图片路径
      proListVisible: false,
      stockIODataList: [],
      departmentList: [],
      OperationTypeList: [],
    };
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询列表
    initTable() {
      const {
        Operator,
        tdate,
        department,
        operationType,
        SourceNo,
        ContainerNo,
        SKU,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        Operator,
        OrgDepartmentID: thereAre(department),
        OperationType: thereAre(operationType),
        SourceNo,
        ContainerNo,
        SKU,
      };

      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetDeliverGoodProductionReport(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let ProductionInfoIDs = row
        .map((item) => item.productionInfoID)
        .join(",");
      const {
        Operator,
        tdate,
        department,
        operationType,
        SourceNo,
        ContainerNo,
        SKU,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        Operator,
        OrgDepartmentID: thereAre(department),
        OperationType: thereAre(operationType),
        SourceNo,
        ContainerNo,
        SKU,
        ProductionInfoIDs,
      };

      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      ExportDeliverGoodProductionReport(para).then((res) => {
        loading.close();
        if (res.data.success) {
          var data = res.data.response;
          if (data != null) {
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });

          return;
        }
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
      //预览图片
    getReadyImages(id, type) {
      const data = {
        stockingTaskID: id,
        type: type,
      };

      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getReadyforTaskReviewImages(data).then((res) => {
        console.log(res);
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },

       //预览图片
    getLoadCarInfoImages(id) {
      const data = {
        loadCarInfoID: id,
      };
      //this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getLoadCarInfoReviewImages(data).then((res) => {
        console.log(res);
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    getImage(id) {
      const data = {
        signForID: id,
      };
      this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getSignForImage(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.showPreviewImg = true;
          const { response } = res;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });

          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
          // setTimeout(function(){
          //   document.querySelector('#ImgEle').click()
          // },500)
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;

    //加载基础资料

    getDepartmentList({ orgId: user.organizationId }).then((res) => {
      this.departmentList = res.data.response;
    });

    //加载基础资料

    GetDeliverGoodProductionTypeList().then((res) => {
      this.OperationTypeList = res.data.response;
    });
  },
};
</script>